import { SAVE_ACCOUNT_SETTINGS } from '../actions/account'
import { IS_NOT_AUTHENTICATED } from '../../authorization/actions/security'

const accountSettings = (state = null, action) => {
  switch (action.type) {
  case SAVE_ACCOUNT_SETTINGS:
    return action.accountSettings
  case IS_NOT_AUTHENTICATED:
    return null
  default:
    return state
  }
}

export default accountSettings
